import type { ChatSession } from "../../AiToolboxSection.types";
import ChatHistoryDropdown from "../ChatHistoryDropdown/ChatHistoryDropdown";
import { AiAssistantCreateSessionButton } from "./components/AiAssistantCreateSessionButton/AiAssistantCreateSessionButton";
import { AiAssistantMaximizeButton } from "./components/AiAssistantMaximizeButton/AiAssistantMaximizeButton";

export interface AiAssistantHeaderActionsProps {
  sessions: ChatSession[];
  activeSessionId: string | null;
  onSwitchSession: (sessionId: string) => void;
  onDeleteSession: (sessionId: string) => void;
  onRenameSession: (sessionId: string, newTitle: string) => void;
  onCreateNewSession: () => void;
  onMaximize?: () => void;
}

const AiAssistantHeaderActions = ({
  sessions,
  activeSessionId,
  onSwitchSession,
  onDeleteSession,
  onRenameSession,
  onCreateNewSession,
  onMaximize,
}: AiAssistantHeaderActionsProps) => (
  <>
    <ChatHistoryDropdown
      sessions={sessions}
      activeSessionId={activeSessionId}
      onSwitchSession={onSwitchSession}
      onDeleteSession={onDeleteSession}
      onRenameSession={onRenameSession}
    />
    <AiAssistantCreateSessionButton onCreateNewSession={onCreateNewSession} />
    {onMaximize && <AiAssistantMaximizeButton onMaximize={onMaximize} />}
  </>
);

export default AiAssistantHeaderActions;
